import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';

const CONSULTATIONS: string[] = [
	'internalMedicine',
	'pediatrics',
	'cardiology',
	'endocrinology',
	'gastroenterology',
	'nephrology',
	'pneumology',
	'neurology',
	'dermatology',
	'psychiatry',
	'clinicalPsychology',
	'rheumatology',
	'infectology',
	'oncology',
	'hematology',
	'emergencyMedicine',
	'familyMedicine',
	'geriatrics',
	'generalSurgery',
	'plasticSurgery',
	'neurosurgery',
	'cardiovascularSurgery',
	'thoracicSurgery',
	'pediatricSurgery',
	'orthopedicSurgery',
	'spineSurgery',
	'urology',
	'ophthalmology',
	'otorhinolaryngology',
	'gynecologyAndObstetrics',
	'anesthesiology',
	'radiologyAndImaging',
	'pathology',
	'medicalGenetics',
	'painMedicine',
	'palliativeMedicine',
	'physicalMedicineAndRehabilitation',
	'sportsMedicine',
	'nutritionAndDietetics',
	'occupationalMedicine',
	'socialWork',
	'imaging',
	'speechTherapy',
	'occupationalTherapy',
	'psychotherapy',
	'nursing',
	'endocrinologyConsultation',
	'cardiologyConsultation',
	'ophthalmologyConsultation',
	'dentalExamination',
	'nutritionalAssessment',
	'psychologicalConsultation',
	'podiatricExamination',
	'gynecologicalExamined',
	'urologicalExamined',
];

export const useHealthPlanOtherConsultationsFormScheme = () => {
	const getFormSchemeForDiabetes = (): ItemScheme[] => {
		const scheme: ItemScheme[] = [];
		CONSULTATIONS.forEach(item => {
			scheme.push({
				type: MagicField.CHECKBOX,
				key: item,
				title: `component.healthPlanOtherConsultations.${item}`,
				settings: {
					hideRequired: true,
				},
			});
		});
		return scheme;
	};

	return {
		getFormSchemeForDiabetes,
	};
};
